import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=57c70b5f&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=57c70b5f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57c70b5f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('57c70b5f')) {
      api.createRecord('57c70b5f', component.options)
    } else {
      api.reload('57c70b5f', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=57c70b5f&scoped=true&", function () {
      api.rerender('57c70b5f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-29WWMpi3zCEAy/JS/comp/SearchFilterTokens.vue"
export default component.exports